import { useNavigate } from "react-router-dom";

const WaitingActivation = () => {
  const navigate = useNavigate();

  return (
    <div>
      <h2>Twoje konto oczekuje na aktywację przez administratora.</h2>
      <p>Skontaktuj się z administratorem, aby aktywować konto.</p>

      <button onClick={() => navigate("/login")} style={{ marginTop: 12 }}>
        Wróć do logowania
      </button>
    </div>
  );
};

export default WaitingActivation;
